import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PersonModal from '../../../Modals/PersonModal/PersonModal';

function PersonTableRow(props) {
    const { callback, eventID } = props;
    const [ modalShow, setModalShow ] = useState(false);
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <span className="btn btn-link btn-sm float-right" style={{fontWeight: 'bold'}} size="sm" onClick={() => setModalShow(true)}>{t('general.create_new')}</span>
            {modalShow ?
                <PersonModal
                    show={modalShow}
                    person={{}}
                    callback={callback}
                    onHide={() => setModalShow(false)}
                    eventID={eventID}
                />
            : null}
        </React.Fragment>
    )
}

export default PersonTableRow;